import { Box, Title } from "@mantine/core";
import type { ReactNode } from "react";
import classes from "./SheetGroup.module.css";

export interface SheetGroupProps {
  title: string;
  note?: ReactNode;
  children: ReactNode;
}

/** Canvas 3.1: Odoo маягийн хуудасны бүлэг — гарчиг (том үсэг), зураас, мөрүүд. */
export function SheetGroup({ title, note, children }: SheetGroupProps) {
  return (
    <Box className={classes.root}>
      <Box className={classes.head}>
        <Title order={2} className={classes.title}>
          {title}
        </Title>
        {note && <Box className={classes.note}>{note}</Box>}
      </Box>
      {children}
    </Box>
  );
}
